import getApi from '../../api/apisauceConfig'
import { DictationSession } from '../../model/DictationSession'

export const startDictation = () => getApi().get<DictationSession>('/voice_ai/dictation/start')
